const team2023 = {
    title: "2023",
    members: [
      {
        name: "message.team.management",
        members: [
          {
            img: "/static/team/members/simon_aubin_lavoie.jpg",
            fullName: "SIMON AUBIN-LAVOIE",
            role: "message.team.roles.captain",
            mail: "s.aubinlavoie.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/simon-aubin-lavoie/",
          },
          {
            img: "/static/team/members/samuel_gagne.jpg",
            fullName: "SAMUEL GAGNÉ",
            role: "message.team.roles.technical-director",
            mail: "s.gagne.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/samuel-gagne-978529183",
          },
        ],
      },
      {
        name: "message.team.aerodynamic",
        members: [
          {
            img: "/static/team/members/daniel_gavrila.jpg",
            fullName: "Daniel Gavrila",
            role: "message.team.roles.lead-aerodynamics",
            mail: "d.gavrila.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/daniel-gavrila-59665318a/",
          },
          {
            img: "/static/team/members/maxim_brasseur.jpg",
            fullName: "Maxim Brasseur",
            role: "",
            mail: "m.brasseur.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/maximbrasseur/",
          },
          {
              img: "/static/team/members/gustave_dromain.jpg",
              fullName: "Gustave Dromain",
              role: "",
              mail: "g.dromain.formule.ets@gmail.com",
              linkedin: "https://www.linkedin.com/in/gustave-dromain-9b590a181/",
          },
          {
            img: "/static/team/members/eline_houri.jpg",
            fullName: "Eline Houri",
            role: "",
            mail: "e.houri.formule.ets@gmail.com",
            linkedin: "",
          },
          {
            img: "/static/team/members/lucas_brilland.jpg",
            fullName: "Lucas Brilland",
            role: "",
            mail: "l.brilland.formule.ets@gmail.com",
            linkedin: "",
          },
          {
            img: "",
            fullName: "Anthony Gomes",
            role: "",
            mail: "a.gomes.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/anthony-gomes-/",
          },
        ],
      },
      {
        name: "message.team.chassis",
        members: [
          {
            img: "/static/team/members/samuel_gagne.jpg",
            fullName: "SAMUEL GAGNÉ",
            role: "message.team.roles.lead-chassis",
            mail: "s.gagne.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/samuel-gagne-978529183",
          },
          {
            img: "/static/team/members/etienne_paillereau.jpg",
            fullName: "Etienne Paillereau",
            role: "",
            mail: "e.paillereau.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/etienne-paillereau-746855203",
          },
        ],
      },
      {
        name: "message.team.dynamics",
        members: [
          {
            img: "/static/team/members/lea_bruneau.jpg",
            fullName: "Léa Bruneau",
            role: "message.team.roles.lead-dynamic",
            mail: "l.bruneau.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/l%C3%A9a-bruneau-6a045921b/",
          },
          {
            img: "/static/team/members/charles_deschenes.jpg",
            fullName: "Charles Deschenes",
            role: "",
            mail: "c.deschenes.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/charles-deschenes-b1970829b/",
          },
          {
            img: "/static/team/members/alexandre_valsorda.jpg",
            fullName: "ALEXANDRE VALSORDA",
            role: "",
            mail: "a.valsorda.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/alexandre-valsorda-3015831a5/",
          },
          {
            img: "/static/team/members/charles_barette.jpg",
            fullName: "Charles Barette",
            role: "",
            mail: "c.barette.formule.ets@gmail.com",
            linkedin: "",
          },
          {
            img: "/static/team/members/lea_tonini.jpg",
            fullName: "Léa Tonini",
            role: "",
            mail: "l.tonini.formule.ets@gmail.com",
            linkedin: "",
          },
        ],
      },
      {
        name: "message.team.control",
        members: [
          {
            img: "/static/team/members/steve_groleau.jpg",
            fullName: "Steve Groleau",
            role: "message.team.roles.lead-control",
            mail: "s.groleau.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/steve-groleau-1636a01b9/",
          },
        ],
      },
      {
        name: "message.team.electronics",
        members: [
          {
            img: "/static/team/members/felix_groleau.jpg",
            fullName: "Félix Groleau",
            role: "message.team.roles.lead-electronic",
            mail: "f.groleau.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/f%C3%A9lix-groleau-28b5b3231",
          },
          {
            img: "/static/team/members/jerome_bolduc.jpg",
            fullName: "Jérôme Bolduc",
            role: "",
            mail: "j.bolduc.formule.ets@gmail.com",
            linkedin:"https://www.linkedin.com/in/j%C3%A9r%C3%B4me-bolduc-7083191b1/",
          },
          {
            img: "/static/team/members/alexis_st-pierre.jpg",
            fullName: "Alexis St-Pierre",
            role: "",
            mail: "a.stpierre.formule.ets@gmail.com",
            linkedin:"",
          },
        ],
      },
      {
        name: "message.team.drivetrain",
        members: [
          {
            img: "/static/team/members/karl_vreeze.jpg",
            fullName: "Karl de Vreeze",
            role: "message.team.roles.lead-drivetrain",
            mail: "k.devreeze.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/karl-de-vreeze-89524b180/",
          },
          {
            img: "/static/team/members/tommy_gelinas.jpg",
            fullName: "Tommy Gélinas",
            role: "",
            mail: "t.gelinas.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/tommy-g%C3%A9linas-4a3935245/",
  
          },
          {
            img:"/static/team/members/alek_cyr.jpg",
            fullName:"Alek Cyr",
            role:"",
            mail:"a.cyr.formule.ets@gmail.com",
            linkedin:"https://www.linkedin.com/in/alek-cyr-9397b6192"
            }
        ],
      },
      {
        name: "message.team.powertrain",
          members: [
              {
                  img: "/static/team/members/jean_carlo.jpg",
                  fullName: "Jean-Carlo Doray",
                  role: "message.team.roles.lead-powertrain",
                  mail: "jc.doray.formule.ets@gmail.com",
                  linkedin: "https://www.linkedin.com/in/jean-carlo-doray-b8614423b",
              },
              {
                  img: "/static/team/members/zacharie_morin.jpg",
                  fullName: "Zacharie Morin",
                  role: "",
                  mail: "z.morin.formule.ets@gmail.com",
                  linkedin: "",
              },
              {
                img: "/static/team/members/alexis_st-pierre.jpg",
                fullName: "Alexis St-Pierre",
                role: "",
                mail: "a.stpierre.formule.ets@gmail.com",
                linkedin:"",
              },
          ]
      },
      {
        name: "message.team.machining",
        members: [
          {
            img: "/static/team/members/tommy_gelinas.jpg",
            fullName: "Tommy Gélinas",
            role: "message.team.roles.lead-machining",
            mail: "t.gelinas.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/tommy-g%C3%A9linas-4a3935245/",
          },
          {
            img: "/static/team/members/alexandre_valsorda.jpg",
            fullName: "ALEXANDRE VALSORDA",
            role: "",
            mail: "a.valsorda.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/alexandre-valsorda-3015831a5/",
          },
          {
            img: "/static/team/members/charles_deschenes.jpg",
            fullName: "Charles Deschenes",
            role: "",
            mail: "c.deschenes.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/charles-deschenes-b1970829b/",
          },
          {
            img: "/static/team/members/samuel_gagne.jpg",
            fullName: "Samuel Gagné",
            role: "",
            mail: "s.gagne.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/samuel-gagn%C3%A9-5a5b3b1b9/",
          },
          {
            img: "/static/team/members/steve_groleau.jpg",
            fullName: "Steve Groleau",
            role: "",
            mail: "s.groleau.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/steve-groleau-1636a01b9/",
          },
          {
            img: "/static/team/members/maxim_brasseur.jpg",
            fullName: "Maxim Brasseur",
            role: "",
            mail: "m.brasseur.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/maximbrasseur/",
          },
        ],
      },
      {
        name: "message.team.driverless",
          members: [
              {
                  img: "/static/team/members/komi_kevin.jpg",
                  fullName: "Komi Kevin Awator",
                  role: "message.team.roles.lead-driverless",
                  mail: "k.awator.formule.ets@gmail.com",
                  linkedin: "http://linkedin.com/in/kevin-awator",
              },
              {
                img: "/static/team/members/charles_barette.jpg",
                fullName: "Charles Barette",
                role: "message.team.roles.lead-driverless-mec",
                mail: "c.barette.formule.ets@gmail.com",
                linkedin: "",
            },
            {
              img: "/static/team/members/shawn_killeen.jpg",
              fullName: "Shawn Killeen",
              role: "",
              mail: "s.killeen.formule.ets@gmail.com",
              linkedin: "https://www.linkedin.com/in/shawnkilleen/",
            },
            {
              img: "/static/team/members/raphael_roumat.jpg",
              fullName: "Raphaël Roumat",
              role: "",
              mail: "r.roumat.formule.ets@gmail.com",
              linkedin: "",
            },
            {
              img: "/static/team/members/zacharie_morin.jpg",
              fullName: "Zacharie Morin",
              role: "",
              mail: "z.morin.formule.ets@gmail.com",
              linkedin: "",
          },
          {
            img: "/static/team/members/nicolas_gaulin-metivier.jpg",
            fullName: "Nicolas Gaulin-Métivier ",
            role: "",
            mail: "n.gaulinmetivier.formule.ets@gmail.com",
            linkedin: "",
        },
            ]
      },
      {
        name: "message.team.external_relationship",
        members: [
          {
            img: "/static/team/members/thomas_viejo.jpg",
            fullName: "Thomas Viejo",
            role: "message.team.roles.lead-external-relationship",
            mail: "t.viejo.formule.ets@gmail.com",
            linkedin:
              "https://www.linkedin.com/in/thomas-viejo-9a213b195/?originalSubdomain=fr",
          },
          {
            img: "/static/team/members/melina_gasparini.jpg",
            fullName: "Mélina Gasparini",
            role: "",
            mail: "m.gasparini.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/melina-gasparini-cpi-cep-631991141/",
          },
          {
              img: "/static/team/members/gustave_dromain.jpg",
              fullName: "Gustave Dromain",
              role: "",
              mail: "g.dromain.formule.ets@gmail.com",
              linkedin: "https://www.linkedin.com/in/gustave-dromain-9b590a181/",
          },
          {
            img: "/static/team/members/lea_tonini.jpg",
            fullName: "Léa Tonini",
            role: "",
            mail: "l.tonini.formule.ets@gmail.com",
            linkedin: "",
          },
          {
            img: "/static/team/members/mathilde_vigon.jpg",
            fullName: "Mathilde Vigon",
            role: "",
            mail: "m.vigon.formule.ets@gmail.com",
            linkedin: "",
          },
          {
            img: "/static/team/members/shawn_killeen.jpg",
            fullName: "Shawn Killeen",
            role: "",
            mail: "s.killeen.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/shawnkilleen/",
          },
        ],
      },
      {
        name: "message.team.statics",
        members: [
          {
            img: "/static/team/members/lea_tonini.jpg",
            fullName: "Léa Tonini",
            role: "",
            mail: "l.tonini.formule.ets@gmail.com",
            linkedin: "",
          },
          {
            img: "/static/team/members/eline_houri.jpg",
            fullName: "Eline Houri",
            role: "",
            mail: "e.houri.formule.ets@gmail.com",
            linkedin: "",
          },
        ],
      },
      
    ],
  };
  
  export default team2023;